import { QuestionFormatType } from '../types/form-engine.types';

/** Legacy enum ReviewType member names. */
export type ReviewTypeKey = 'self' | 'peer' | 'annual' | 'confirmation' | 'half_yearly' | 'special' | 'management';

/** Legacy enum AssesmentType member names: arf, crf, hyrf, srf, uhrf. */
export type AssessmentTypeKey = 'arf' | 'crf' | 'hyrf' | 'srf' | 'uhrf';

/** Legacy enum PeerCategory member names. */
export type PeerCategoryKey = 'Senior' | 'Junior' | 'Equal' | 'Other';

export const QUESTION_FORMATS: { key: QuestionFormatType; title: string }[] = [
  { key: 'short-text', title: 'SHORT_TEXT' },
  { key: 'long-text', title: 'LONG_TEXT' },
  { key: 'multiple-choice', title: 'MULTIPLE_CHOICE' },
  { key: 'checkboxes', title: 'CHECKBOXES' },
  { key: 'rating', title: 'RATING' },
  { key: 'date', title: 'DATE' },
  { key: 'likert-scale', title: 'LIKERT_SCALE' },
  { key: 'nps', title: 'NPS' },
];

export const REVIEW_TYPES: { key: ReviewTypeKey; title: string }[] = [
  { key: 'self', title: 'SELF' },
  { key: 'peer', title: 'PEER' },
  { key: 'annual', title: 'ANNUAL' },
  { key: 'confirmation', title: 'CONFIRMATION' },
  { key: 'half_yearly', title: 'HALF_YEARLY' },
  { key: 'special', title: 'SPECIAL' },
  { key: 'management', title: 'MANAGEMENT' },
];

export const ASSESSMENT_TYPES: { key: AssessmentTypeKey; title: string; reviewTypes: ReviewTypeKey[] }[] = [
  { key: 'arf', title: 'ANNUAL_REVIEW', reviewTypes: ['self', 'peer', 'annual'] },
  { key: 'crf', title: 'CONFIRMATION_REVIEW', reviewTypes: ['peer', 'confirmation'] },
  { key: 'hyrf', title: 'HALF_YEARLY_REVIEW', reviewTypes: ['peer', 'half_yearly'] },
  { key: 'srf', title: 'SPECIAL_REVIEW', reviewTypes: ['peer', 'special'] },
  { key: 'uhrf', title: 'DEPARTMENT_HEAD_REVIEW', reviewTypes: ['self', 'peer', 'management'] },
];

export const PEER_CATEGORIES: { key: PeerCategoryKey; title: string }[] = [
  { key: 'Senior', title: 'SENIOR' },
  { key: 'Junior', title: 'JUNIOR' },
  { key: 'Equal', title: 'EQUAL' },
  { key: 'Other', title: 'OTHER' },
];


/** A peer request must have peers spread across at least this many peer categories. */
export const MIN_CATEGORIES_WITH_PEERS = 3;

export const DEFAULT_LIKERT_LABELS = ['Strongly Disagree', 'Disagree', 'Neutral', 'Agree', 'Strongly Agree'];

export const getReviewTypesForAssessment = (assessmentType: string) =>
  ASSESSMENT_TYPES.find((type) => type.key === assessmentType)?.reviewTypes ?? REVIEW_TYPES.map((type) => type.key);
